import React, { useCallback } from 'react';

import { messagesModel, selectMessages, selectOption } from '@/features';
import { useAppDispatch, useAppSelector, useParametricSelector } from '@/store';

import { ColorOption } from './FieldOptions/ColorOption';

export const ColorOptions: React.FC<{
  messageId: string;
  choices: messagesModel.ColorChoice[];
}> = ({ messageId, choices }) => {
  const dispatch = useAppDispatch();
  const isAwaitingAnswer = useAppSelector(
    (state) => state.messages.awaitingAnswer,
  );

  const selectedOption = useParametricSelector(
    selectMessages.makeSelectedOptionSelector,
    messageId,
  );

  const disabled =
    useAppSelector(selectMessages.newestVisitorOptionsFieldsMessageId) !==
      messageId ||
    Boolean(selectedOption) ||
    isAwaitingAnswer;

  const handleOptionClick = useCallback(
    (option: string) => {
      dispatch(
        selectOption({
          answerTo: messageId,
          option,
        }),
      );
    },
    [dispatch, messageId],
  );

  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
      {choices.map(({ choice, description }, idx) => (
        <ColorOption
          key={idx}
          onClick={handleOptionClick}
          color={choice}
          text={description}
          selected={(description ?? choice) === selectedOption}
          disabled={disabled}
        />
      ))}
    </div>
  );
};
